import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware } from 'redux';
import { createRootReducers, rootSagas } from 'src/state/ducks';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';

export const history = createBrowserHistory();
const composeEnhancers = composeWithDevTools({
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
});
const sagaMiddleware = createSagaMiddleware();
// Store にマウントする
const store = createStore(
  createRootReducers(history),
  composeEnhancers(
    applyMiddleware(
      sagaMiddleware,
      routerMiddleware(history), // for dispatching history actions
      // ... other middlewares ...
    ),
  ),
);
sagaMiddleware.run(rootSagas);

export default store;
